const $ = jQuery.noConflict();
'use strict';

$(function() {
	const heroVideo = {
		video: document.getElementsByClassName('js-hero-banner-video__video')[0],

		init: function() {
			if (!this.video) {
				return;
			}
			this.toggleControls();
			window.addEventListener('resize', this.toggleControls.bind(this));

			if (document.readyState === 'complete') {
				this.loadVideo();
			} else {
				window.addEventListener('load', this.loadVideo.bind(this));
			}
		},

		loadVideo: function() {
			const src = this.video.dataset.src;
			if (!src) {
				return;
			}
			this.video.src = src;
			this.video.play().catch(() => {});
		},

		toggleControls: function() {
			if (window.innerWidth <= 768) {
				this.video.removeAttribute('controls');
			} else {
				this.video.setAttribute('controls', 'controls');
			}
		},
	};

	heroVideo.init();
});